export default __webpack_public_path__ + "static/media/logo.a04ab3e9.png";